import { types, getParent, flow } from 'mobx-state-tree';
import { CenterAdminRow } from './models';

const CenterAdminsStore = types
  .model('CenterAdminsStore', {
    centerAdmins: types.array(CenterAdminRow),
  })
  .volatile(self => ({
    loading: false,
  }))
  .views(self => ({
    get root() {
      return getParent(self);
    },
  }))
  .actions(self => ({
    loadCenterAdmins: flow(function* () {
      try {
        self.loading = true;
        const response = yield self.root.api.centerAdmin.index();
        self.centerAdmins = response.data.data;
      } catch (error) {
        self.root.ui.toast.error(error);
      }
      self.loading = false;
    }),
    destroy: flow(function* (id) {
      let response;
      if (window.confirm('Are you sure to delete it?')) {
        try {
          self.loading = true;
          response = yield self.root.api.centerAdmin.destroy(id);
          self.loadCenterAdmins();
        } catch (error) {
          self.root.ui.toast.error(error);
        }
        self.loading = false;
      }
    }),
  }))


export default CenterAdminsStore;
